module.exports = __webpack_public_path__ + "img/gift2-05-c1.c6105b6e.png";